import * as tslib_1 from "tslib";
import styled from '../styles';
import SimpleIcon from './SimpleIcon';
import { colorCss } from '../utils/colors';
var Icon = styled(SimpleIcon).attrs({
    color: function (props) { return props.color || 'currentColor'; },
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), colorCss);
Icon.sinouiName = 'Icon';
Icon.displayName = 'Icon';
export default Icon;
var templateObject_1;
//# sourceMappingURL=Icon.js.map